import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);
const routes = new Router({
    // mode: 'history', //后端支持可开
    routes: [
        {path: '/', redirect: '/invoice'},
        {path: '/login', component: resolve => require(['../components/page/Login.vue'], resolve)},
        {path: '/createAccount', component: resolve => require(['../components/page/Login.vue'], resolve), meta: {authMode: 'register'}},
        {
            path: '/aa', component: resolve => require(['../components/common/home.vue'], resolve),
            children: [
                {path: '/client', component: resolve => require(['../components/page/client.vue'], resolve)},
                {path: '/clientUpdate', component: resolve => require(['../components/page/clientUpdate.vue'], resolve)},
                {path: '/clientCreate', component: resolve => require(['../components/page/clientCreate.vue'], resolve)},
                {path: '/item',component: resolve => require(['../components/page/item.vue'], resolve)},
                {path: '/itemCreate',component: resolve => require(['../components/page/itemCreate.vue'], resolve)},
                {path: '/itemUpdate',component: resolve => require(['../components/page/itemUpdate.vue'], resolve)},
                {path: '/invoice', component: resolve => require(['../components/page/invoice.vue'], resolve)},
                {path: '/invoiceCreate',component: resolve => require(['../components/page/invoiceCreate.vue'], resolve)},
                {path: '/invoiceUpdate',component: resolve => require(['../components/page/updateInvoice.vue'], resolve)},
                {path: '/setting',component: resolve => require(['../components/page/setting.vue'], resolve)},
                {path: '/company_info',component: resolve => require(['../components/page/companyInfo.vue'], resolve)},
                // {path: '/payment_info',component: resolve => require(['../components/page/paymentInfo.vue'], resolve)},
                {path: '/default',component: resolve => require(['../components/page/default.vue'], resolve)},
                {path: '/invoice-design',component: resolve => require(['../components/page/invoiceDesign.vue'], resolve)},
                {path: '/account',component: resolve => require(['../components/page/account.vue'], resolve)},
                {path: '/feedback',component: resolve => require(['../components/page/feedback.vue'], resolve)},
                {path: '/report',component: resolve => require(['../components/page/report.vue'], resolve)},
                {path: '/expense',component: resolve => require(['../components/page/expenses.vue'], resolve)},
                {path: '/estimate',component: resolve => require(['../components/page/estimate.vue'], resolve)},
                {path: '/purchaseOrder',component: resolve => require(['../components/page/estimate.vue'], resolve)},
                {path: '/createEstimate',component: resolve => require(['../components/page/createEstimate.vue'], resolve)},
                {path: '/updateEstimate',component: resolve => require(['../components/page/updateEstimate.vue'], resolve)},
                {path: '/createExpense',component: resolve => require(['../components/page/CreateExpense.vue'], resolve)},
                {path: '/updateExpense',component: resolve => require(['../components/page/updateExpense.vue'], resolve)},
                {path: '/createStatement',component: resolve => require(['../components/page/createStatement.vue'], resolve)}
            ]
        },
        {
            path: '*',
            component: resolve => require(['../components/page/404.vue'], resolve)  // 404
        }
    ]
})

/*routes.beforeEach((to, from, next) => {
    // let hospitalData = localStorage.getItem("hospitalData")
    next();
    // if(!hospitalData||hospitalData==''){
    //     if(to.path=='/login'){//如果是登录页面路径，就直接next()
    //         next();
    //     }else{//不然就跳转到登录
    //        next('/login');
    //     }
    // }else{
    //   next();
    // }
})*/

export default routes;
